import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { EpaApi } from '../../../../services'
import { IPublicWaterSystem } from '../../../../types'
import { IEventMilestone } from '../../../../types/EventMilestone'

interface RequestOptions {
  pwsid: string,
  options?: AxiosRequestConfig
}

export const fetchPWSEventMilestonesAsync = createAsyncThunk<{}, RequestOptions>(
  'pws/eventmilestones/fetch',
  async ({ pwsid: id, options = {} }, { rejectWithValue }) => {
    try {
      const request = await EpaApi.getPubWaterSystem(id, options) as AxiosResponse<IEventMilestone[]>
      return request.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const fetchPWSEventMilestonesAsyncBuilder = (builder: any) => {
  builder.addCase( fetchPWSEventMilestonesAsync.fulfilled, (state, action) => {

    state.eventMilestones.loading = false
    state.eventMilestones.success = true
    state.eventMilestones.data = action.payload
  })
  builder.addCase( fetchPWSEventMilestonesAsync.rejected, (state, action) => {
    state.eventMilestones.loading = false
    state.eventMilestones.success = false
    state.eventMilestones.error = action.payload
  })
  builder.addCase( fetchPWSEventMilestonesAsync.pending, (state, action) => {
    state.eventMilestones.loading = true
    state.eventMilestones.success = false
    state.eventMilestones.error = ''
  })
}